import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChatMessage } from './global-chat.models';

export const GlobalChatActions = createActionGroup({
  source: 'GlobalChat',
  events: {
    Load: emptyProps(),
    'Set Chat Messages': props<{ messages: ChatMessage[] }>(),
  },
});
